export default __webpack_public_path__ + "bd7630c98f1bab000380961c35917ac5.svg";